<template>
  <div>
    <Breadcrumbs main="Clientes" title="Editar Cliente" v-if="objectId"/>
    <Breadcrumbs main="Clientes" title="Agregar Cliente" v-else/>
    <!-- Container-fluid starts-->
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <h5 v-if="objectId">Editar Cliente</h5>
              <h5 v-else>Agregar Cliente</h5>
            </div>
            <div class="card-body">
              <b-form class="needs-validation">
                <div class="form-row">
                  <div class="col-md-12 mb-3">
                    <label for="username_id">RUT (requerido)</label>
                    <masked-input class="form-control" id="username_id"
                                  v-model="form.rut.value"
                                  placeholder="12.345.678-9"
                                  :mask="maskRUT"
                    />
                    <b-form-invalid-feedback :state="form.rut.is_valid">{{form.rut.message_error}}</b-form-invalid-feedback>
                  </div>
                  <div class="col-md-12 mb-3">
                    <label for="business_name_id">Razón Social (requerido)</label>
                    <b-form-input
                        type="text" id="business_name_id" placeholder="Veramonte"
                        v-model="form.business_name.value">
                    </b-form-input>
                    <b-form-invalid-feedback :state="form.business_name.is_valid">{{form.business_name.message_error}}</b-form-invalid-feedback>
                  </div>
                  <div class="col-md-12 mb-3">
                    <label for="business_name_id">Email de correos automáticos (opcional)</label>
                    <b-form-input
                        type="email" id="email_id" placeholder="correo@correo.com"
                        v-model="form.email.value">
                    </b-form-input>
                    <b-form-invalid-feedback :state="form.email.is_valid">{{form.email.message_error}}</b-form-invalid-feedback>
                  </div>
                  <div class="col-md-12 mb-3">
                    <label for="business_name_id">Habilitar envío de correos (requerido)</label>
                    <multiselect placeholder="Selecciona un tipo"
                                 label="name" track-by="id"
                                 deselectLabel="Click para eliminar" selectLabel="Seleccionar"
                                 v-model="form.send_email.value" :options="form.send_email.options"
                                 @input="setRequiredEmail"
                                 :searchable="true" :close-on-select="true" :show-labels="true" :allow-empty="false">
                      <template slot="noResult">No se encontraron elementos, por favor, cambie el filtro de búsqueda.</template>
                      <template slot="noOptions">No hay clientes disponibles.</template>
                    </multiselect>
                    <b-form-invalid-feedback :state="form.send_email.is_valid">{{form.send_email.message_error}}</b-form-invalid-feedback>
                  </div>
                  <div class="col-md-12 mb-3">
                    <label for="tracking_path">Url de tracking (www.tracking.gmscorreo.cl/tracking/{{form.path_tracking.value}}/)</label>
                    <b-form-input
                        type="text" id="tracking_path" placeholder=""
                        v-model="form.path_tracking.value">
                    </b-form-input>
                    <b-form-invalid-feedback :state="form.path_tracking.is_valid">{{form.path_tracking.message_error}}</b-form-invalid-feedback>
                  </div>
                  <div class="col-md-12 mb-3">
                    <label for="color_id">Color en los gráficos (requerido)</label>
                    <b-form-input
                        type="color" id="color_id" placeholder=""
                        v-model="form.color.value" value="#000000">
                    </b-form-input>
                    <b-form-invalid-feedback :state="form.color.is_valid">{{form.color.message_error}}</b-form-invalid-feedback>
                  </div>
                </div>
                <b-button type="button" variant="primary" @click="onSubmit" v-if="objectId">Editar cliente</b-button>
                <b-button type="button" variant="success" @click="onSubmit" v-else>Agregar cliente</b-button>
                <b-button type="button" variant="warning" class="ml-1" :to="{'name': 'CoreClientList'}">Volver</b-button>
              </b-form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Container-fluid Ends-->
  </div>
</template>

<script>
import axios from 'axios';
import MaskedInput from 'vue-masked-input'
import utils from '../../../utils';
import Multiselect from 'vue-multiselect';

export default {
  components: {
    MaskedInput,
    Multiselect
  },
  data(){
    return {
      objectId: null,
      form: {
        rut: utils.defaultFields(),
        business_name: utils.defaultFields(),
        path_tracking: utils.defaultFields(),
        email: utils.defaultFields({
          required: false,
        }),
        send_email: utils.defaultFields({
          _type: 'select',
          options: [
            {'id': true, 'name': 'Si'},
            {'id': false, 'name': 'No'},
          ],
          value: {'id': false, 'name': 'No'},
        }),
        color: utils.defaultFields({value: '#000000'}),
      },
      maskRUT: {
        pattern: '##.###.###-V',
        formatCharacters: {
          'V': {
            validate: char => /[1-9kK]/.test(char),
            transform: char => char.toUpperCase(),
          },
        },
      },
    }
  },
  mounted () {
    this.objectId = this.$route.params.objectId;
    if(this.objectId){
      this.loadData(this.objectId);
    }
  },
  methods: {
    setRequiredEmail() {
      this.form.email.required = this.form.send_email.value.id;
    },
    onSubmit(evt){
      // console.log(evt)
      evt.preventDefault();
      // AQUÍ GUARDARÉ EL JSON FINAL PARA QUE SEA ENVIADO AL POST
      let data = {};
      const is_valid = utils.generateJsonStructure(this.form, data);
      if(is_valid){
        let _type = 'agregar al cliente';
        if(this.objectId){
          _type = 'modificar el cliente'
        }
        this.$swal({
          title: 'Información',
          type: 'info',
          html: `Estás a punto de ${_type} <b>${this.form.business_name.value} (${this.form.rut.value})</b>.`,
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false,
          confirmButtonColor: '#28a745',
          confirmButtonText: '<i class="fa fa-thumbs-up"></i> Continuar',
          cancelButtonColor: '#dc3545',
          cancelButtonText: '<i class="fa fa-thumbs-down"></i> Cancelar',
          showLoaderOnConfirm: true,
          preConfirm: async () => {
            if(!this.objectId){
              const path = '/api/core/v1.0/client/';
              await axios.post(path, data).then(async () => {
                // console.log(response);
                await this.$swal({
                  title: 'Agregado',
                  type: 'success',
                  html: `Se ha agregado al cliente <b>${this.form.business_name.value} (${this.form.rut.value})</b> de manera correcta.`,
                }).then(() => {
                  this.$router.push({'name': 'CoreClientList'});
                });
              }).catch(async (error) => {
                // ERROR 401 DA CUANDO NO SE ENVÍA EL TOKEN
                if(error.response.status === 400){
                  console.log(error.response);
                  utils.generateBackendError(this.form, error.response.data);
                  await this.$swal({
                    title: 'Error',
                    type: 'error',
                    html: `Hay campos que no han sido completados correctamente, por favor, verifica nuevamente el formulario.`,
                  });
                }
              });
            } else {
              const path = `/api/core/v1.0/client/${this.objectId}/`;
              await axios.patch(path, data).then(async () => {
                // console.log(response);
                await this.$swal({
                  title: 'Modificado',
                  type: 'success',
                  html: `Se ha modificado al cliente <b>${this.form.business_name.value} (${this.form.rut.value})</b> de manera correcta.`,
                }).then(() => {
                  this.$router.push({'name': 'CoreClientList'});
                });
              }).catch(async (error) => {
                // ERROR 401 DA CUANDO NO SE ENVÍA EL TOKEN
                console.log(error.response.data);
                if(error.response.status === 400){
                  console.log(error.response);
                  utils.generateBackendError(this.form, error.response.data);
                  await this.$swal({
                    title: 'Error',
                    type: 'error',
                    html: `Hay campos que no han sido completados correctamente, por favor, verifica nuevamente el formulario.`,
                  });
                }
              });
            }
          }
        });
      } else {
        this.$swal({
          title: 'Error',
          type: 'error',
          html: `Hay campos que no han sido completados correctamente, por favor, verifica nuevamente el formulario.`,
        });
      }
    },
    async loadData(objectId){
      let data = {};
      let responseData;
      const defaultFieldValues = {
        email: {
          required: false,
        }
      };
      const path = `/api/core/v1.0/client/${objectId}/`;
      await axios.get(path).then(async (response) => {
        responseData = response.data;
        await utils.loadDataStructure(data, responseData, defaultFieldValues);
        data.send_email = this.form.send_email;
        data.send_email.value = this.form.send_email.options.find(item => item['id'] === responseData['send_email']);
        data.email.required = data.send_email.value.id;
      }).catch((error) => {
        console.log(error.response);
      });
      await this.$set(
          this,
          'form',
          data
      );
    }
  }
}
</script>